import api from "@/api";

const state = {
  users: { data: [], paging: {} },
  // admin: 1
  // storekeeper: 2
  // mechanic: 3
  // supervisor: 4
  userTypes: []
};
const getters = {
  userTypes: state => {
    return state.userTypes;
  },
  list: state => {
    return state.users;
  }
};

const actions = {
  async getList({ commit }, params) {
    const result = await api.get(`/api/v1/users/index/`, params);
    if (result && result.status == 200) {
      commit("setList", result.data);
      return result.data;
    } else return null;
  },
  async getUserTypes({ commit }) {
    const result = await api.get(`/api/v1/users/types/`);
    if (result && result.status == 200) {
      commit("setUserTypes", result.data.data);
      return true;
    } else return false;
  },
  async delete({ commit }, payload) {
    const result = await api.put(`/api/v1/users/delete/${payload}/`);
    if (result && result.status == 200) {
      // commit("removeItem", payload);
      return result.data.data;
    }
    return null;
  },
};
const mutations = {
  setUserTypes(state, payload) {
    state.userTypes = payload;
  },
  setList(state, payload) {
    state.users = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
